'use strict';

var React = require('react');

var SvgArchiveMinor = function SvgArchiveMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3a1.5 1.5 0 0 0-1.5 1.5v1.5h14v-1.5a1.5 1.5 0 0 0-1.5-1.5h-11zm-.5 12.5a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-7.5h-12v7.5zm3-4.5h6v2h-6v-2z"
  }));
};

exports.SvgArchiveMinor = SvgArchiveMinor;
